import {BOOLEAN, NUMBER, property, STRING} from '../config/Properties.ts';

export const KUBERNETES_ENV_PREFIX = 'io.bridge.kubernetes';




export const SERVICE_DNS = property<string>('service-dns', STRING);
export const SERVICE_NAME = property<string>('service-name', STRING);
export const SERVICE_LABEL_NAME = property<string>('service-label-name', STRING);
export const SERVICE_LABEL_VALUE = property<string>('service-label-value', STRING);
export const NAMESPACE = property<string>('namespace', STRING);
export const POD_LABEL_NAME = property<string>('pod-label-name', STRING);
export const POD_LABEL_VALUE = property<string>('pod-label-value', STRING);
export const EXPOSE_EXTERNALLY = property<boolean>('expose-externally', BOOLEAN);
export const SERVICE_PER_POD_LABEL_NAME = property<string>('service-per-pod-label-name', STRING);
export const SERVICE_PER_POD_LABEL_VALUE = property<string>('service-per-pod-label-value', STRING);
export const RESOLVE_NOT_READY_ADDRESSES = property<boolean>('resolve-not-ready-addresses', BOOLEAN);

export const KUBERNETES_MASTER_URL = property<string>('kubernetes-master', STRING);
export const KUBERNETES_API_TOKEN = property<string>('api-token', STRING);
export const SERVICE_PORT = property<number>('service-port', NUMBER);
